import { render, staticRenderFns } from "./SellerOffers.vue?vue&type=template&id=4cd6571e&scoped=true"
import script from "./SellerOffers.vue?vue&type=script&lang=js"
export * from "./SellerOffers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cd6571e",
  null
  
)

export default component.exports